// ─────────────────────────────────────────────────────────────
// Modifica qui tutti i valori della pagina.
// ─────────────────────────────────────────────────────────────

export const offer = {
  productName: 'Flauto Master',
  price: '$27',
  currency: 'USD',
  bonusCount: '5',
  totalValue: '$133',
  guaranteeDays: '10',
  checkoutUrl: 'https://flauta-master-ita.impultienda.ar/checkout',
  metaPixelId: '2290894421720846',
  priceValue: 27,
  supportEmail: '[EMAIL DE SOPORTE]',
  // Data reale di fine promo in formato ISO, es. '2026-10-15T23:59:59+02:00'.
  // Se lasciata vuota, il conto alla rovescia termina a mezzanotte di oggi.
  promoEnd: '',
  // URL dell'immagine grande del bundle nell'hero. Vuoto = mockup generato.
  heroImage: '',
};

export const shortQuote = {
  text: 'Prima improvvisavo ogni lezione. Ora stampo la scheda la sera prima e so esattamente cosa fare.',
  author: 'Laura B., Milano',
};

export const pains = [
  'Passi ore a cercare esercizi sparsi su internet prima di ogni lezione.',
  'Con 25 bambini e 25 flauti, il suono diventa caos e non sai da dove iniziare a correggere.',
  'Improvvisi la lezione cinque minuti prima di entrare in classe.',
  'Non hai un percorso chiaro per portare la classe dalla prima nota a una melodia suonata insieme.',
];

export const mainProduct = {
  label: 'Il libro principale · PDF',
  title: 'Il Flauto Dolce in Classe',
  subtitle: 'Guida del docente + 50 esercizi',
  value: '$56',
  cover: '',
  description:
    'Un unico libro con tutto quello che ti serve: la parte teorica per te e 50 esercizi pronti per la classe, in un percorso in 7 fasi dalla prima nota alla melodia d’insieme.',
  features: [
    'Guida teorica del docente: percorso in 7 fasi, spiegato passo per passo',
    '50 esercizi di una pagina con obiettivo, schema visivo e 4 passaggi',
    'Varianti più facili e più sfidanti, da SI–LA–SOL fino a DO’ e RE’',
    '9 melodie originali da suonare tutti insieme',
    'Lezioni pronte da 30 e 45 minuti + registro di osservazione stampabile',
  ],
};

export const purchaseNotifications = [
  { name: 'Giulia', city: 'Firenze', ago: '2 minuti fa' },
  { name: 'Paolo', city: 'Genova', ago: '4 minuti fa' },
  { name: 'Sara', city: 'Bari', ago: '6 minuti fa' },
  { name: 'Elena', city: 'Padova', ago: '9 minuti fa' },
  { name: 'Davide', city: 'Cagliari', ago: '11 minuti fa' },
  { name: 'Martina', city: 'Trieste', ago: '14 minuti fa' },
  { name: 'Roberta', city: 'Perugia', ago: '17 minuti fa' },
  { name: 'Simone', city: 'Brescia', ago: '20 minuti fa' },
];

export const bonuses = [
  {
    number: '01',
    title: 'Teoria Musicale Facile: 20 Schede Visive',
    value: '$17',
    cover: 'https://cdn.magicpatterns.com/uploads/vTuy1ayGDPg9g8mxurunCR/img_bono_1.webp',
    description:
      '20 schede illustrate per spiegare note, figure ritmiche e pentagramma in modo visivo, anche ai più piccoli.',
  },
  {
    number: '02',
    title: 'Repertorio per la Classe: 20 Brani Tradizionali',
    value: '$19',
    cover: 'https://cdn.magicpatterns.com/uploads/61aPebFzm5iCZ1rWXWQVnH/img_bono_2.webp',
    description:
      '20 brani tradizionali arrangiati per flauto dolce e ordinati per difficoltà, perfetti per saggi e recite.',
  },
  {
    number: '03',
    title: 'Giochi Musicali senza Flauto: 30 Attività',
    value: '$15',
    cover: 'https://cdn.magicpatterns.com/uploads/hQrkiKD3Bs7xAJyRU5b74x/img_bono_3.webp',
    description:
      '30 giochi di ritmo, ascolto e movimento per lavorare la musicalità quando i flauti restano nello zaino.',
  },
  {
    number: '04',
    title: 'Kit di Valutazione e Diplomi',
    value: '$12',
    cover: 'https://cdn.magicpatterns.com/uploads/9drgmQtmRfCPDuKexfKpay/img_bono_4.webp',
    description:
      'Griglie di osservazione, rubriche di valutazione pronte e diplomi da consegnare agli alunni a fine percorso.',
  },
  {
    number: '05',
    title: 'Poster e Flashcard per l’Aula',
    value: '$14',
    cover: 'https://cdn.magicpatterns.com/uploads/w4RmMCmWFs4T8BTNW9EFe9/img_bono_5.webp',
    description:
      'Poster delle diteggiature e flashcard delle note da appendere in classe o da usare durante i giochi.',
  },
];

export const formatNotIncluded = ['Niente video', 'Niente audio', 'Niente libri cartacei'];

export const formatIncluded = [
  { title: 'Solo file PDF', text: 'Pronti da stampare o da proiettare su tablet e LIM.' },
  { title: 'Consegna via email', text: 'Ricevi il link per scaricare tutto nella tua casella di posta.' },
  { title: 'Accesso immediato', text: 'Il materiale arriva pochi minuti dopo il pagamento.' },
  { title: 'Pagamento unico', text: 'Paghi una sola volta. Nessun abbonamento, mai.' },
];

export const steps = [
  { title: 'Scarica', text: 'Ricevi subito il libro e tutti i bonus in PDF nella tua email.' },
  { title: 'Stampa', text: 'Stampa la scheda della lezione in due minuti. È tutto già impaginato.' },
  { title: 'Insegna', text: 'Segui il percorso, mostra lo schema e guarda la classe progredire.' },
];

export const testimonials = [
  {
    text: 'Ho stampato la prima scheda la sera prima e la lezione è filata liscia. In due settimane la classe suonava SI–LA–SOL tutta insieme!',
    name: 'Chiara',
    city: 'Verona',
    time: '08:42',
  },
  {
    text: 'Finalmente un percorso chiaro. Non passo più le domeniche a cercare esercizi su internet: apro il PDF e sono pronta.',
    name: 'Alessandra',
    city: 'Roma',
    time: '13:15',
  },
  {
    text: 'I giochi senza flauto mi hanno salvato nelle classi più vivaci. Materiale semplice e bellissimo da stampare.',
    name: 'Valentina',
    city: 'Palermo',
    time: '19:27',
  },
];

export const buyers = [
  {
    name: 'Marco R.',
    city: 'Torino',
    role: 'Insegnante di musica, primaria',
    photo: 'https://cdn.magicpatterns.com/uploads/rpqRsMZYeLx6wa5TD1xmGW/images.jpg',
    quote:
      'Insegno da poco e la guida mi ha dato la sicurezza di entrare in classe sapendo esattamente cosa fare.',
  },
  {
    name: 'Giuseppe L.',
    city: 'Bologna',
    role: 'Docente di educazione musicale',
    photo: 'https://cdn.magicpatterns.com/uploads/r74L3VfrqpNHMiEZRkVrpo/img_flau_2.jpg',
    quote: 'In trent’anni di scuola non avevo mai avuto un materiale così ordinato. Lo uso con tutte le mie quinte.',
  },
  {
    name: 'Francesca M.',
    city: 'Napoli',
    role: 'Maestra di classe, primaria',
    photo: 'https://cdn.magicpatterns.com/uploads/rHLJATypj1dTrvetNn9wkU/img_flau.jpg',
    quote: 'Poster e flashcard sono appesi in aula da settembre. I bambini ormai riconoscono le note da soli.',
  },
  {
    name: 'Laura B.',
    city: 'Milano',
    role: 'Insegnante di musica, primaria',
    photo: 'https://cdn.magicpatterns.com/uploads/4eMRctcHmRZpWFCh25dAkc/img_flu_3.jpg',
    quote: 'Pagamento unico, PDF subito nella mail e la lezione pronta in dieci minuti. Proprio quello che mi serviva.',
  },
];

export const offerItems = [
  { label: 'Libro: Il Flauto Dolce in Classe (guida + 50 esercizi)', value: '$56' },
  { label: 'Bonus 1: Teoria Musicale Facile', value: '$17' },
  { label: 'Bonus 2: Repertorio per la Classe', value: '$19' },
  { label: 'Bonus 3: Giochi Musicali senza Flauto', value: '$15' },
  { label: 'Bonus 4: Kit di Valutazione e Diplomi', value: '$12' },
  { label: 'Bonus 5: Poster e Flashcard per l’Aula', value: '$14' },
];

export const paymentMethods = ['Visa', 'Mastercard', 'PayPal', 'Apple Pay', 'Google Pay'];

export const faqs = [
  {
    question: 'In che formato ricevo il pack?',
    answer:
      'Tutto il materiale è in formato PDF in alta qualità, pronto da stampare o da usare su tablet e LIM. Non ci sono video, audio né libri cartacei.',
  },
  {
    question: 'Come ricevo il materiale?',
    answer: 'Subito dopo il pagamento ricevi un’email con il link per scaricare tutti i PDF. Accesso immediato.',
  },
  {
    question: 'Il pagamento è unico?',
    answer: 'Sì. Paghi una sola volta 27 USD e il materiale resta tuo per sempre. Nessun abbonamento.',
  },
  {
    question: 'Va bene anche se non sono un flautista?',
    answer:
      'Sì. Ogni scheda spiega cosa mostrare, cosa far provare e cosa osservare, con un linguaggio chiaro e senza teoria complicata.',
  },
  {
    question: 'Posso stampare le schede per tutta la classe?',
    answer: 'Sì, puoi stamparle per i tuoi alunni tutte le volte che vuoi.',
  },
  {
    question: 'E se il pack non fa per me?',
    answer: 'Hai 10 giorni di garanzia: scrivici una email e ti rimborsiamo per intero, senza domande.',
  },
];
